<p-floatLabel>
  <p-select #questionGroupDropdown
      id="questionGroupDropdown"
      name="questionGroupDropdown"
      [options]="questionGroups"
      [(ngModel)]="questionGroup"
      [showClear]="!isRequired"
      [checkmark]="true"
      [filter]="true"
      [filterBy]="'name'"
      [optionLabel]="'name'"
      [appendTo]="'body'"
      styleClass="w-100"
      optionLabel="name"
      [disabled]="isDisabled"
      (onChange)="onSelected()"
      (onClick)="$event.stopPropagation()">
    <ng-template let-option pTemplate="item">
      {{ option.name }}
    </ng-template>
  </p-select>
  <label for="questionGroupDropdown">
    <app-label-content [isRequired]="isRequired && !isDisabled">
      {{ l('::QuestionGroup') }}
    </app-label-content>
  </label>
</p-floatLabel>
